import { SVGProps } from 'react';

const PenSmall = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="#36576D"
    fill="#D9D9D9"
    {...props}
  >
    <path
      d="M14.6228 6.92697L4.79244 16.7574C3.9012 17.6486 3.9012 19.0936 4.79244 19.9848V19.9848C5.68368 20.8761 7.12866 20.8761 8.0199 19.9848L17.9416 10.0632M14.6228 6.92697L18.1593 3.39053C19.0505 2.49929 20.4955 2.49929 21.3867 3.39053V3.39053C22.278 4.28177 22.278 5.72675 21.3867 6.61799L17.9416 10.0632M14.6228 6.92697L17.9416 10.0632"
      fill="none"
    />
    <rect
      x="7.22086"
      y="17.0718"
      width="7.31772"
      height="0.718376"
      rx="0.359188"
      transform="rotate(-45 7.22086 17.0718)"
    />
    <path
      d="M3.14286 21.8571L1.5 23.5M3.14286 21.8571V20.35C3.14286 20.2174 3.19554 20.0902 3.2893 19.9964L4.28571 19M3.14286 21.8571H4.65004C4.78264 21.8571 4.90982 21.8045 5.00359 21.7107L6 20.7143"
      fill="none"
    />
  </svg>
);

export default PenSmall;
